import styled from 'styled-components';
import { getMediaQuery } from '@carvana/showroom-theme';

import { InnerSection, Section } from '../../../styles/section/section';

export const StyledContactFlow = styled(Section)`
  min-height: auto;
`;

export const StyledContactFlowContainer = styled(InnerSection)`
  padding: 2rem 0 3rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.sm)} {
    padding: 3rem 0 4rem;
  }
`;


export const StyledContactFlowModule = styled.div`
  & > div {
    max-width: 800px;
    margin: 0 auto;
  }
`;
